<template>
    <transition name="toolbar-slide">
        <div
            v-if="isToolbarVisible"
            class="emails-toolbar-container"
            :class="{ 'listingBatchToolbar--new': useNewUi }"
        >
            <div class="scheduled-emails-toolbar">
                <span class="typographies-paragraph-medium-bold btn-cancel-selected-items">
                    <CompassIconButton
                        icon="close"
                        :variant="CompassEnums.IconButtonVariant.CONTRAST"
                        @click="closeToolbar"
                    />
                    {{
                        $t.n__(
                            'common.labels.selected',
                            null,
                            selectedEmails.length,
                            selectedEmails.length,
                        )
                    }}
                </span>
                <CompassButton
                    :label="$t.__('common.actions.delete')"
                    :type="CompassEnums.ButtonType.TERTIARY_CONTRAST"
                    leftIcon="bin"
                    @click="handleDelete"
                />
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import Feature from 'Services/Feature';
interface SelectedEmail {
    id: string;
}

interface Props {
    selectedEmails?: SelectedEmail[];
    isToolbarVisible?: boolean;
}

withDefaults(defineProps<Props>(), {
    selectedEmails: () => [],
    isToolbarVisible: false,
});

const emit = defineEmits<{
    (event: 'closeToolbar'): void;
    (event: 'open:delete'): void;
}>();

const useNewUi: boolean = Feature.isEnabled('new-listing-ui');

const closeToolbar = (): void => {
    emit('closeToolbar');
};

const handleDelete = (): void => {
    emit('open:delete');
};
</script>

<style scoped lang="scss">
.toolbar-slide-enter-active,
.toolbar-slide-leave-active {
    transition: transform 0.3s ease-in-out;
}

.toolbar-slide-enter-from,
.toolbar-slide-leave-to {
    transform: translateY(110px);
}

.toolbar-slide-enter-to,
.toolbar-slide-leave-from {
    transform: translateY(0);
}

.emails-toolbar-container {
    position: fixed;
    left: 184px;
    right: 120px;
    bottom: var(--spacing-6);
    z-index: 3;

    &.listingBatchToolbar--new {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        bottom: auto;
        margin-top: var(--spacing-4);
    }
}

.scheduled-emails-toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-radius: var(--spacing-0);
    padding: var(--spacing-3) var(--spacing-4);
    gap: var(--spacing-3);
    color: var(--colors-common-text-standard-on-color);
    background-color: var(--colors-common-border-primary-hover);
}

.btn-cancel-selected-items {
    display: flex;
    align-items: center;
    gap: var(--spacing-0);
    padding-right: var(--spacing-4);
    border-right: 1px solid var(--colors-common-border-lighter);
}
</style>
